// extracted by mini-css-extract-plugin
module.exports = {"selector":"src-components-layouts-selector-module__selector--3VhWk"};